import {NgComponentOutlet} from '@angular/common';
import {ChangeDetectionStrategy, Component, ElementRef, Input, ViewChild} from '@angular/core';
import {ComponentCatalogComponent} from '../../component-catalog.decorator';

@Component({
  selector: 'cc-component-content',
  templateUrl: './component-content.component.html',
  styleUrls: ['./component-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ComponentContentComponent {
  @Input() component: ComponentCatalogComponent;

  @ViewChild(NgComponentOutlet, { read: ElementRef }) outlet: NgComponentOutlet;
}
